/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CateringFormOrganizationQueryVariables = Types.Exact<{
  name: Types.Scalars['String']
}>

export type CateringFormOrganizationQuery = {
  __typename: 'Query'
  organization: {
    __typename: 'Organization'
    id: number
    name: string
    cateringEmailCustomer: string | null
    cateringLogo: {
      __typename: 'ImageAttachment'
      id: number
      variantUrl: string
    } | null
  } | null
}

export const CateringFormOrganizationQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CateringFormOrganizationQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'seoName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'name' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cateringEmailCustomer' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cateringLogo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'variantUrl' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'format' },
                            value: { kind: 'EnumValue', value: 'png' }
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'height' },
                            value: { kind: 'IntValue', value: '200' }
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'width' },
                            value: { kind: 'IntValue', value: '300' }
                          }
                        ]
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode

/**
 * __useCateringFormOrganizationQuery__
 *
 * To run a query within a React component, call `useCateringFormOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCateringFormOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCateringFormOrganizationQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCateringFormOrganizationQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    CateringFormOrganizationQuery,
    CateringFormOrganizationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CateringFormOrganizationQuery,
    CateringFormOrganizationQueryVariables
  >(CateringFormOrganizationQueryDocument, options)
}
export function useCateringFormOrganizationQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CateringFormOrganizationQuery,
    CateringFormOrganizationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CateringFormOrganizationQuery,
    CateringFormOrganizationQueryVariables
  >(CateringFormOrganizationQueryDocument, options)
}
export type CateringFormOrganizationQueryHookResult = ReturnType<
  typeof useCateringFormOrganizationQuery
>
export type CateringFormOrganizationQueryLazyQueryHookResult = ReturnType<
  typeof useCateringFormOrganizationQueryLazyQuery
>
export type CateringFormOrganizationQueryQueryResult = Apollo.QueryResult<
  CateringFormOrganizationQuery,
  CateringFormOrganizationQueryVariables
>
